import type { CurrentUser, PlatformPermission } from "../api";

export function hasPermission(
  user: CurrentUser,
  permission: PlatformPermission
): boolean {
  return user.permissions.includes(permission);
}
